import React from 'react';

const SvgCsa = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="CSA_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="CSA_svg__b" fill="#fff">
        <use xlinkHref="#CSA_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#CSA_svg__a" />
      <path fill="#19BFBF" mask="url(#CSA_svg__b)" d="M0 0h28v20H0z" />
      <path
        d="M10 16.336c0-.185.036-.48.082-.663l.503-2.013.163-.654.504-2.012a1.36 1.36 0 0 0-.023-.64l-.458-1.375a.916.916 0 0 0-.4-.46l-.742-.371a.578.578 0 0 1-.296-.475V5.66c0-.18.067-.46.148-.623l.371-.741.296-.592.37-.741a.594.594 0 0 1 .49-.296h3.318c.188 0 .34.142.34.336v.66c0 .186.143.337.337.337h.66c.186 0 .337.143.337.336v.66c0 .187.129.402.306.49l2.055 1.028a.59.59 0 0 1 .306.49v.66c0 .185-.067.469-.148.632l-.371.741a1.51 1.51 0 0 1-.426.482l-1.444.962a1.468 1.468 0 0 0-.431.492l-1.027 2.054a1.536 1.536 0 0 1-.431.492l-1.444.962a1.468 1.468 0 0 0-.431.492l-1.028 2.054a.59.59 0 0 1-.49.306h-.66a.331.331 0 0 1-.336-.336v-.66z"
        fill="#FFF"
        mask="url(#CSA_svg__b)"
      />
    </g>
  </svg>
);

export default SvgCsa;
